import { render, staticRenderFns } from "./taoTinTuc.vue?vue&type=template&id=34b03b40&"
import script from "./taoTinTuc.vue?vue&type=script&lang=js&"
export * from "./taoTinTuc.vue?vue&type=script&lang=js&"
import style0 from "./taoTinTuc.vue?vue&type=style&index=0&id=34b03b40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports